'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$36(evaluator$36) {
  this.LD = null;
  this.LD = evaluator$36;
}
export { $c_Lsamples_Persons$package$$anon$36 as $c_Lsamples_Persons$package$$anon$36 };
$p = $c_Lsamples_Persons$package$$anon$36.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$36;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$36() {
}
export { $h_Lsamples_Persons$package$$anon$36 as $h_Lsamples_Persons$package$$anon$36 };
$h_Lsamples_Persons$package$$anon$36.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.LD.h();
  return (((typeof v) === "number") ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Persons$package$$anon$36 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$36, "samples.Persons$package$$anon$36", ({
  pS: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$36 as $d_Lsamples_Persons$package$$anon$36 };
